const prefix = 'uf/painting';

export const UPDATE_SCENARIO_PAINTING_STATUS = `${prefix}/UPDATE_SCENARIO_PAINTING_STATUS`;
export const UPDATE_PROJECT_PAINTING_STATUS = `${prefix}/UPDATE_PROJECT_PAINTING_STATUS`;

export const SET_BASE_EDIT_KEY_ONLY = `${prefix}/SET_BASE_EDIT_KEY_ONLY`;
export const SET_BASE_EDIT_CONFIRMED_SAFE = `${prefix}/SET_BASE_EDIT_CONFIRMED_SAFE`;
